"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var common_1 = require("../connectors/common");
var constants_1 = require("../constants");
var local_storage_1 = require("./local-storage");
var persistor = function persistor(connector) {
  connector.on(common_1.ConnectorEvents.ADDRESS_CHANGED, function (address) {
    (0, local_storage_1.setTypedStorageKey)(constants_1.localStorageKeys.lastUsedAddress, address);
  });
  // This might not be needed since we tend to just recreated connectors when network switches
  connector.on(common_1.ConnectorEvents.NETWORK_CHANGED, function (networkName) {
    (0, local_storage_1.setTypedStorageKey)(constants_1.localStorageKeys.lastUsedNetwork, networkName);
  });
  connector.on(common_1.ConnectorEvents.CONNECTED, function (params) {
    (0, local_storage_1.setTypedStorageKey)(constants_1.localStorageKeys.lastUsedNetwork, params.networkName);
    (0, local_storage_1.setTypedStorageKey)(constants_1.localStorageKeys.lastUsedWalletType, params.walletType);
    (0, local_storage_1.setTypedStorageKey)(constants_1.localStorageKeys.lastUsedAddress, params.address);
    if (params.index) {
      (0, local_storage_1.setTypedStorageKey)(constants_1.localStorageKeys.lastUsedIndex, params.index);
    }
    if (params.walletId) {
      (0, local_storage_1.setTypedStorageKey)(constants_1.localStorageKeys.lastUsedWalletId, params.walletId);
    }
    (0, local_storage_1.rememberWallet)(params.walletType, params.walletId);
  });
  connector.on(common_1.ConnectorEvents.DISCONNECTED, function () {
    (0, local_storage_1.clearPreviousConfig)();
  });
};
exports.default = persistor;